import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error Library not migrated yet
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import styled from '../../../components/Theme';
import { getAvatarUrl } from '../avatarQueries';
const Avatar = styled(UIAvatar).withConfig({
  displayName: "AvatarViewer__Avatar",
  componentId: "sc-130au0d-0"
})(["box-sizing:border-box;"]);

const AvatarPreview = ({
  avatarHash,
  imagePreview,
  lastUpdated,
  size = 'xl'
}) => {
  let src = null;

  if (imagePreview) {
    src = imagePreview;
  } else if (avatarHash) {
    const query = {};

    if (lastUpdated) {
      query.lastUpdated = lastUpdated.toString();
    }

    src = getAvatarUrl(avatarHash, query);
  }

  return /*#__PURE__*/_jsx(Avatar, {
    size: size,
    src: src
  });
};

export default AvatarPreview;